module.exports = __webpack_public_path__ + "img/hr-hazard-concrete-left.f4fc77b5.png";